export default __webpack_public_path__ + "b4025d65eb57d8b3dd5acf81574499b6.jpg";